<template>
  <div>    
    <slot name="dados-basicos"></slot>
   
    <div class="secao-dados" style="margin-bottom: 1.15rem;" v-if="mandatos && mandatos.length">
      <div class="caixa-filtro-status">
        <span class="item-rotulo">Filtrar por status</span>
        <select id="filtroStatusMandato" v-model="filtroStatusSelecionado">
          <option value="">Todos</option>
          <option v-for="st in statusDisponiveis" :key="st" :value="st">{{ st }}</option>
        </select>
      </div>
    </div>

    <!-- Lista de Mandatos -->
    <div v-if="mandatosFiltrados && mandatosFiltrados.length">
      <div 
        class="secao-dados" 
        style="margin-bottom: 1.15rem;"
        v-for="mandato in mandatosFiltrados" 
        :key="mandato.id"
      >
        <!-- Cabeçalho do Mandato -->
        <div class="cabecalho-mandato">
          <h2 class="secao-titulo-texto">
            {{ formatarNomeProprio(mandato.nome_membro) || 'Membro Não Identificado' }}
          </h2>
          
          <div class="acoes-topo" v-if="permissoes.pode_editar && abaAtiva === 'informacoes'">
            <a :href="'/colegiados/colegiado-edit/' + colegiado.id">
              <button id="botao-editar" class="btn-acao btn-editar">Editar Colegiado</button>
            </a>
            <button id="botao-excluir" class="btn-acao btn-excluir" @click.prevent="modalExclusaoVisivel = true">Excluir Colegiado</button>
          </div>
        </div>
        
        <div class="grade-dados">
          <!-- === LINHA 1 === -->
          <div class="item-dado" v-if="permissoes.pode_criar">
            <span class="item-rotulo">Cód. SISCOL</span>
            <span class="item-valor">{{ mandato.id }}</span>
          </div>
          <div class="item-dado">
            <span class="item-rotulo">CPF do Membro</span>
            <span class="item-valor">{{ formatarCPF(mandato.cpf_membro) }}</span>
          </div>
          <div class="item-dado">
            <span class="item-rotulo">Cargo do Membro</span>
            <span class="item-valor">{{ mandato.cargo_membro ? formatarNomeProprio(mandato.cargo_membro) : 'Nenhum cargo encontrado' }}</span>
          </div>
          <div class="item-dado">
            <span class="item-rotulo">Tipo do Membro</span>
            <span class="item-valor" style="text-transform: capitalize;">{{ mandato.tipo_membro || '-' }}</span>
          </div>

          <!-- === LINHA 2 === -->
          <div class="item-dado">
            <span class="item-rotulo">Função</span>
            <span class="item-valor">{{ getFuncao(mandato.funcao) || '-' }}</span>
          </div>
          <div class="item-dado">
            <span class="item-rotulo">Tipo de Mandato</span>
            <span class="item-valor">{{ mandato.tipo_mandato || '-' }}</span>
          </div>
          <div class="item-dado">
            <span class="item-rotulo">Data de Início</span>
            <span class="item-valor">{{ formatarData(mandato.data_inicio) }}</span>
          </div>
          <div class="item-dado">
            <span class="item-rotulo">Data de Término</span>
            <span class="item-valor">{{ formatarData(mandato.data_termino) }}</span>
          </div>

          <!-- LINHA 3 (3 itens) -->
          <div class="item-dado">
            <span class="item-rotulo">Categoria Representada</span>
            <span class="item-valor">{{ mandato.categoria_representativa || '-' }}</span>
          </div>

          <div class="item-dado">
            <span class="item-rotulo">Status do Mandato</span>
            <span class="item-valor">{{ mandato.status_mandato || '-' }}</span>
          </div>

          <div class="item-dado">
            <span class="item-rotulo">Ato de Nomeação</span>
            <span class="item-valor">{{ mandato.ato_nomeacao || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
        
    <div v-else-if="mandatos && mandatos.length" class="mensagem-vazio">
      <p>Nenhum mandato encontrado para o status selecionado</p>
    </div>
    <div v-else class="mensagem-vazio">
      <p>Sem mandatos cadastrados</p>
    </div>
  
    <!--  MODAL DE EXCLUSÃO DE MANDATO  -->    
      
    <div v-if="modalExclusaoVisivel" class="modal-exclusao">
      <div class="modal-mask">
        <div class="modal-container">
          <div class="modal-header">
            <h2>Deseja mesmo excluir este Mandato?</h2>
          </div>
          <div class="modal-body" v-if="mandatoSelecionado">
            <p>Dados do Mandato:</p>
            <div class="dados">
              <div class="flexbox">
                <div class="texto-centralizado">
                  Código Mandato: <span>{{ mandatoSelecionado.id }}</span>
                </div>
                <div class="texto-centralizado">
                  CPF: <span>{{ formatarCPF(mandatoSelecionado.cpf_membro) }}</span>
                </div>
                <div class="texto-centralizado">
                  Nome: <span>{{ formatarNomeProprio(mandatoSelecionado.nome_membro) }}</span>
                </div>
                <div class="texto-centralizado">
                  Cargo: <span>{{ mandatoSelecionado.cargo_membro ? formatarNomeProprio(mandatoSelecionado.cargo_membro) : 'Não informado' }}</span>
                </div>
                <div class="texto-centralizado">
                  Função: <span>{{ getFuncao(mandatoSelecionado.funcao) || '-' }}</span>
                </div>
              </div>
              <div class="flexbox">
                <div class="texto-centralizado">
                  Tipo de Membro: <span style="text-transform: capitalize;">{{ mandatoSelecionado.tipo_membro || '-' }}</span>
                </div>
                <div class="texto-centralizado">
                  Tipo de Mandato: <span>{{ mandatoSelecionado.tipo_mandato || '-' }}</span>
                </div>
                <div class="texto-centralizado">
                  Data de Início: <span>{{ formatarData(mandatoSelecionado.data_inicio) }}</span>
                </div>
                <div class="texto-centralizado">
                  Data de Término: <span>{{ formatarData(mandatoSelecionado.data_termino) }}</span>
                </div>
                <div class="texto-centralizado">
                  Categoria Representada: <span>{{ mandatoSelecionado.categoria_representativa || '-' }}</span>
                </div>
                <div class="texto-centralizado">
                  Status: <span>{{ mandatoSelecionado.status_mandato || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn-confirmar-exclusao" @click="confirmarExclusao">Sim</button>
            <button class="btn-cancelar-exclusao" @click="fecharModalExclusao">Não</button>
          </div>
        </div>
      </div>
    </div>    

  </div> 
</template>

<script>
import { parseISO, format } from "date-fns";
import MandatosApi from "../../services/MandatosApi";

export default {
  name: "ExibirMandatos",
  props: {
    mandatos: Array,
    colegiado: Object,
    permissoes: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      filtroStatusSelecionado: 'Vigente',
      modalExclusaoVisivel: false,
      mandatoSelecionado: null,
    };
  },
  created() {
    this.mandatosApi = new MandatosApi();
  },
  computed: {
    statusDisponiveis() {
      const nomes = (this.mandatos || [])
        .map((mandato) => mandato.status_mandato)
        .filter(Boolean);
      return [...new Set(nomes)].sort();
    },
    mandatosFiltrados() {      
      const ordemStatus = {
        'vigente': 1,
        'aguardando posse': 2,
        'encerrado a pedido': 3,        
      };

      const lista = this.filtroStatusSelecionado
        ? (this.mandatos || []).filter((mandato) => mandato.status_mandato === this.filtroStatusSelecionado)
        : (this.mandatos || []);

      return [...lista].sort((a, b) => {
        const statusA = a.status_mandato ? a.status_mandato.toLowerCase() : '';
        const statusB = b.status_mandato ? b.status_mandato.toLowerCase() : '';
        
        const pesoA = ordemStatus[statusA] || 99;
        const pesoB = ordemStatus[statusB] || 99;
        
        return pesoA - pesoB;
      });
    },
  },
  methods: {
    abrirModalExclusao(mandato) {
      this.mandatoSelecionado = mandato;
      this.modalExclusaoVisivel = true;
    },
    fecharModalExclusao() {
      this.modalExclusaoVisivel = false;
      this.mandatoSelecionado = null;
    },
    async confirmarExclusao() {
      if (!this.mandatoSelecionado) return;

      try {
        if (!this.mandatosApi) this.mandatosApi = new MandatosApi();
        if (this.mandatosApi.cancelTokens && this.mandatosApi.cancelTokens.destroyMandato) {
          this.mandatosApi.cancelTokens.destroyMandato.cancel();
        }

        await this.mandatosApi.destroyMandato(this.mandatoSelecionado.id);
        
        // Recarrega a página para atualizar a lista de mandatos após exclusão
        window.location.reload(); 
      } catch (err) {
        if (this.mandatosApi.isCancel && this.mandatosApi.isCancel(err)) return;
        this.fecharModalExclusao();
        alert("Não foi possível excluir este mandato. Verifique as dependências.");
      }
    },
    formatarNomeProprio(texto) {
      if (!texto) return '';
      const excecoes = ['de', 'da', 'do', 'das', 'dos', 'e', 'em', 'na', 'no', 'nas', 'nos', 'por', 'com', 'para'];
      const siglasConhecidas = ['AGR', 'ALEGO', 'SANEAGO', 'DETRAN', 'SGU', 'SISCOL', 'GOINFRA', 'CPF', 'RG', 'GO', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];
      return texto
        .toString()
        .toLowerCase()
        .split(' ')
        .map(palavra => {
          const palavraLimpa = palavra.replace(/[()]/g, '').toUpperCase();
          if (siglasConhecidas.includes(palavraLimpa)) return palavra.toUpperCase();
          if (excecoes.includes(palavra)) return palavra;
          return palavra.charAt(0).toUpperCase() + palavra.slice(1);
        })
        .join(' ');
    },
    formatarCPF(cpf) {
      if (!cpf) return '';
      cpf = cpf.replace(/\D/g, '');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      return cpf;
    },
    formatarData: function (value) {
      if (!value) return '-';
      return format(parseISO(value), "dd/MM/yyyy");
    },
    getFuncao(value) {
      if (value === 'vicepresidente') return 'Vice-Presidente';
      if (value == 'presidente') return 'Presidente';
      return value;
    }
  },
};
</script>

<style lang="scss" scoped>
/* ESTRUTURA DOS CARDS DE MANDATOS */
.secao-dados {
  background: #fff;
  border: 1px solid #d9e2db;
  border-radius: 0.9rem;
  padding: 1.1rem 1.2rem 1.2rem;
  width: 100%;
  box-sizing: border-box;
}

/* NOVO CABEÇALHO DO MANDATO COM OS BOTÕES */
.cabecalho-mandato {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 0.95rem 0;
  padding: 0; /* Zerei o padding inferior para alinhar melhor sem a linha */
  border-bottom: none; /* A MÁGICA AQUI: remove a linha pontilhada verde */

  .secao-titulo-texto {
    font-family: "Montserrat-Bold", sans-serif;
    font-size: 1.05rem;
    color: #0a4a22;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    margin: 0;
  }

  .acoes-topo {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0; /* Removi a margem para ficar perfeitamente alinhado com o nome */

    .btn-acao {
      font-family: "Montserrat-Medium", sans-serif;
      font-size: 0.9rem;
      padding: 0.3rem 2rem;
      border-radius: 0.2rem;
      cursor: pointer;
      background: transparent;
      transition: 0.2s;
    }

    .btn-editar {
      color: #005516;
      border: #005516 solid 0.15rem;
    }

    .btn-editar:hover {
      color: white;
      background-color: #005516;
    }

    .btn-excluir {
      color: #d32f2f;
      border: #d32f2f solid 0.15rem;
    }

    .btn-excluir:hover {
      color: white;
      background-color: #d32f2f;
    }
  }
}

/* GRID DE DADOS */
.grade-dados {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr)); /* Alterado para 4 colunas */
  gap: 0.85rem 1rem;
}

.item-dado {
  min-width: 0;
  padding: 0.7rem 0.8rem;
  background: #f7f9f7;
  border: 1px solid #e4ebe5;
  border-radius: 0.65rem;
}

.item-dado--largo {
  grid-column: 1 / -1;
}

.item-dado--medio {
  grid-column: span 2;
}

.item-rotulo {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin: 0 0 0.35rem 0;
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.96rem;
  line-height: 1.25;
  color: #005516;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.item-valor {
  display: block;
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.9rem;
  line-height: 1.45;
  color: #1f1f1f;
  word-break: break-word;
  white-space: pre-wrap;
}

.caixa-filtro-status {
  display: flex;
  align-items: center;
  gap: .8rem;
}

  select {
    height: 2.2rem;
    min-width: 12rem;
    padding: 0 .8rem;
    border-radius: 0.5rem;
    border: 1px solid #d9e2db;
    background-color: #f7f9f7;
    font-family: "Montserrat-Medium", sans-serif;
    font-size: 0.9rem;
    color: #1f1f1f;
    cursor: pointer;
  }

  select:focus {
    outline: none;
    border-color: #005516;
  }

.mensagem-vazio {
  background: #fff;
  border: 1px dashed #d9e2db;
  padding: 2rem;
  border-radius: 0.9rem;
  text-align: center;
  margin-top: 1.5rem;

  p {
    font-family: "Montserrat-Medium", sans-serif;
    font-size: 1rem;
    color: #5a6f60;
    margin: 0;
  }
}

/* MODAL DE EXCLUSÃO */
.modal-exclusao {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;

  .modal-mask {
    border-radius: 1rem;
    position: relative;
    z-index: 1000;
    width: 60%;
    max-height: 90vh;
    background-color: #f2f2f2;
    display: flex; 
    flex-direction: column;
  }

  .modal-container {
    padding: .7rem;
    display: flex;
    flex-direction: column;
    height: 100%;
    font-family: "Montserrat-Medium", sans-serif;

    .modal-header h2 {
      font-size: 1.3rem;
      font-weight: bold;
      text-align: center;
      margin-top: 1rem;
      flex-shrink: 0;
    }

    .modal-body {
      border: 1px solid gray;
      border-radius: 1rem;
      text-align: center;
      margin: 1rem;
      padding-bottom: 1rem;
      overflow-y: auto;
      flex-grow: 1;

      p {
        font-size: 1rem;
        font-weight: bold;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        color: #005516;
      }

      .dados {
        text-align: left;
        margin-left: 1rem;
        padding-right: 1rem;
        
        .flexbox {
          display: grid;
          grid-template-columns: 1fr 1fr; 
          gap: 0.5rem 1.5rem; 
          margin-bottom: 0.5rem;
        }

        .texto-centralizado {
          font-weight: bold;
          font-size: 0.95rem;
          color: #000;
          word-break: break-word;
        }

        span {
          font-weight: normal;
          font-size: 0.9rem;
          margin-left: 0.3rem;
          color: #333;
        }
      }
    }

    .modal-footer {
      display: flex;
      justify-content: space-evenly;
      margin-bottom: 1rem;
      flex-shrink: 0;

      .btn-confirmar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #005516;
        color: #f2f2f2;
        cursor: pointer;
      }

      .btn-cancelar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #bd0000;
        color: #f2f2f2;
        cursor: pointer;
      }
    }
  }
}

/* RESPONSIVIDADE GERAL */
@media screen and (max-width: 1065px) {
  .grade-dados {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 900px) {
  .modal-exclusao .modal-mask {
    width: 85%;
  }
}

@media screen and (max-width: 700px) {
  .secao-dados {
    padding: 0.95rem 0.9rem 1rem;
  }
  .grade-dados {
    grid-template-columns: 1fr;
    gap: 0.65rem;
  }
  .item-dado--largo,
  .item-dado--medio {
    grid-column: auto;
  }
  .cabecalho-mandato {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.8rem;
  }
}

@media screen and (max-width: 600px) {
  .modal-exclusao .modal-mask {
    width: 95%;
  }
  .modal-exclusao .modal-container .modal-body .dados .flexbox {
    grid-template-columns: 1fr;
    gap: 0.3rem;
  }
}
</style>